import { Action } from '../../common/actions/core/action';
import { FamilyPlanTypes } from '../../common/services/package/package.model';

export class ManageSubDeleteDialogAction implements Action {
  constructor(
    public type: FamilyPlanTypes
  ) {}
}



// WEBPACK FOOTER //
// src/app/family-plan/manage-sub-delete-dialog/manage-sub-delete-dialog.action.ts